import { Variable } from '../../../../common/models'
import { Modal } from '@/components/ui/modal'
import { Button } from '@/components/ui/button'
import { PageTitle } from '@/components'
import { Icon } from '@/common/components/Icon'

export interface InsertVariableModalProps {
  showModal: boolean
  setShowModal: (show: boolean) => void
  variables: Variable[]
  setInsertVariable: (s: string) => void
}

export const InsertVariableModal = (
  props: InsertVariableModalProps,
): JSX.Element => {
  const { showModal, setShowModal, setInsertVariable, variables } = props

  const handleClose = () => {
    setShowModal(false)
  }

  return (
    <Modal
      open={showModal}
      onOpenChange={setShowModal}
      title={
        <div className="border-b border-monochrome-120 pb-4">
          <PageTitle
            title={
              <span>
                Insert <span className="text-accent-1">Variable</span>
              </span>
            }
            icon="import"
          />
        </div>
      }
      size="lg"
      footer={
        <div className="flex justify-end w-full gap-2 border-t border-monochrome-120 pt-4">
          <Button
            onClick={handleClose}
            variant="secondary"
            className="w-[154px]"
          >
            Cancel
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        {variables.map((variable, index) => (
          <div key={variable.key} className="flex flex-col gap-3">
            <div className="text-xl font-medium leading-tight text-monochrome-1">
              {variable.key}
            </div>
            <div className="text-base text-monochrome-2 leading-normal">
              {variable.description}
            </div>
            <Button
              onClick={() => {
                setInsertVariable(`{${variable.key}}`)
              }}
              variant="secondary"
              className="w-full"
            >
              Insert{' '}
              <Icon icon="plus" width="18" height="18" viewBox="0 0 18 18" />
            </Button>
            {index < variables.length - 1 && (
              <div className="border-t border-monochrome-120 w-full" />
            )}
          </div>
        ))}
      </div>
    </Modal>
  )
}
